var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('v-icon',{staticClass:"mt-1",attrs:{"size":"18"}},[_vm._v("mdi-currency-krw")])]},proxy:true}]),model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }